import { BrowserRouter, Routes, Route } from "react-router-dom";
import Menu from "./components/Menu";
import DirectUpload from "./pages/DirectUpload";
import FrontendCompress from "./pages/FrontendCompress";
import CompressedVideoList from "./pages/CompressedVideoList";

function App() {
  return (
    <BrowserRouter>
      <Menu />
      <Routes>
        <Route path="/" element={<DirectUpload />} />
        <Route path="/frontend-compress" element={<FrontendCompress />} />
        <Route path="/compressed-list" element={<CompressedVideoList />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
